import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import LoadingScreen from "@/components/LoadingScreen";
import { formatDateTime } from "@/lib/utils";

export default function AdminMessagesPage() {
  const [msgs, setMsgs] = useState(null);
  useEffect(() => { api.get("/admin/contact-messages").then(({ data }) => setMsgs(data)); }, []);
  if (!msgs) return <LoadingScreen />;
  return (
    <div className="space-y-3">
      {msgs.length === 0 && (
        <div className="sqit-card p-12 text-center text-gray-500">No contact messages yet.</div>
      )}
      {msgs.map((m) => (
        <div key={m.id} className="sqit-card p-6">
          <div className="flex items-start justify-between">
            <div>
              <div className="font-semibold text-gray-900">{m.name}</div>
              <div className="text-xs text-gray-500">{m.email} · {m.organization || "—"}</div>
            </div>
            <div className="text-xs text-gray-500">{formatDateTime(m.created_at)}</div>
          </div>
          {m.subject && <div className="mt-2 text-sm font-medium">{m.subject}</div>}
          <p className="mt-3 text-sm text-gray-700 whitespace-pre-wrap">{m.message}</p>
        </div>
      ))}
    </div>
  );
}
